import { Permission } from "./types";

// =====================================================
// GLOBAL PERMISSIONS CONSTANTS (All modules)
// =====================================================
export const PERMISSIONS = {
  // ---------------- Profiles ----------------
  PROFILE_CREATE: "profile:create",
  PROFILE_READ: "profile:read",
  PROFILE_UPDATE: "profile:update",
  PROFILE_DELETE: "profile:delete",
  PROFILE_VIEW_PRIVATE: "profile:view_private",
  PROFILE_MANAGE_SEEKING: "profile:manage_seeking",
  PROFILE_MANAGE_STATS: "profile:manage_stats",

  // Access purchases
  ACCESS_CREATE: "access:create",
  ACCESS_READ: "access:read",
  ACCESS_UPDATE: "access:update",
  ACCESS_DELETE: "access:delete",

  // Reactions
  REACTION_CREATE: "reaction:create",
  REACTION_READ: "reaction:read",
  REACTION_UPDATE: "reaction:update",
  REACTION_DELETE: "reaction:delete",

  // Conversations
  CONVERSATION_CREATE: "conversation:create",
  CONVERSATION_READ: "conversation:read",
  CONVERSATION_UPDATE: "conversation:update",
  CONVERSATION_DELETE: "conversation:delete",

  // Messages
  MESSAGE_CREATE: "message:create",
  MESSAGE_READ: "message:read",
  MESSAGE_UPDATE: "message:update",
  MESSAGE_DELETE: "message:delete",

  // ---------------- Products ----------------
  PRODUCT_CREATE: "product:create",
  PRODUCT_READ: "product:read",
  PRODUCT_UPDATE: "product:update",
  PRODUCT_DELETE: "product:delete",
  PRODUCT_STOCK_UPDATE: "product:stock_update",

  // Availability
  AVAILABILITY_CREATE: "availability:create",
  AVAILABILITY_READ: "availability:read",
  AVAILABILITY_UPDATE: "availability:update",
  AVAILABILITY_DELETE: "availability:delete",
  AVAILABILITY_MANAGE: "availability:manage",

  // Bookings
  BOOKING_CREATE: "booking:create",
  BOOKING_READ: "booking:read",
  BOOKING_UPDATE: "booking:update",
  BOOKING_DELETE: "booking:delete",
  BOOKING_CONFIRM: "booking:confirm",
  BOOKING_CANCEL: "booking:cancel",
  BOOKING_COMPLETE: "booking:complete",
  BOOKING_ALLVIEW: "booking:allview",

  // Inventory
  INVENTORY_READ: "inventory:read",
  INVENTORY_LOG: "inventory:log",
  INVENTORY_ADJUST: "inventory:adjust",

  // Tenants
  TENANT_MANAGE: "tenant:manage",

  // Legacy / other
  HOTEL_CREATE: "hotel:create",
  HOTEL_REVIEW: "hotel:review",
  HOTEL_PUBLISH: "hotel:publish",
  HOTEL_APPROVE: "hotel:approve",
  HOTEL_UPDATE: "hotel:update",
  HOTEL_UPLOADIMAGE: "hotel:uploadimage",
  HOTEL_DELETE: "hotel:delete",
  HOTEL_FEATURE: "hotel:feature",

  NOTIFICATION_CREATE: "notification:create",
  NOTIFICATION_UPDATE: "notification:update",
  GET_ALLNOTIFICATIONS: "get:allnotifications",

  LEGALDOCS_CREATE: "legaldocs:create",
  LEGALDOCS_UPDATE: "legaldocs:update",
  LEGALDOCS_DELETE: "legaldocs:delete",

  SETTINGS_MANAGE_SITE: "settings:manage_site",
  DASHBOARD_VIEW_ANALYTICS: "dashboard:view_analytics",
} as const satisfies Record<string, Permission>;

// =====================================================
// GROUPED PERMISSIONS BY MODULE
// =====================================================
export const MODULE_PERMISSIONS: Record<string, Permission[]> = {
  profiles: [
    PERMISSIONS.PROFILE_CREATE,
    PERMISSIONS.PROFILE_READ,
    PERMISSIONS.PROFILE_UPDATE,
    PERMISSIONS.PROFILE_DELETE,
    PERMISSIONS.PROFILE_VIEW_PRIVATE,
    PERMISSIONS.PROFILE_MANAGE_SEEKING,
    PERMISSIONS.PROFILE_MANAGE_STATS,
  ],
  access: [
    PERMISSIONS.ACCESS_CREATE,
    PERMISSIONS.ACCESS_READ,
    PERMISSIONS.ACCESS_UPDATE,
    PERMISSIONS.ACCESS_DELETE,
  ],
  reactions: [
    PERMISSIONS.REACTION_CREATE,
    PERMISSIONS.REACTION_READ,
    PERMISSIONS.REACTION_UPDATE,
    PERMISSIONS.REACTION_DELETE,
  ],
  conversations: [
    PERMISSIONS.CONVERSATION_CREATE,
    PERMISSIONS.CONVERSATION_READ,
    PERMISSIONS.CONVERSATION_UPDATE,
    PERMISSIONS.CONVERSATION_DELETE,
  ],
  messages: [
    PERMISSIONS.MESSAGE_CREATE,
    PERMISSIONS.MESSAGE_READ,
    PERMISSIONS.MESSAGE_UPDATE,
    PERMISSIONS.MESSAGE_DELETE,
  ],
  products: [
    PERMISSIONS.PRODUCT_CREATE,
    PERMISSIONS.PRODUCT_READ,
    PERMISSIONS.PRODUCT_UPDATE,
    PERMISSIONS.PRODUCT_DELETE,
    PERMISSIONS.PRODUCT_STOCK_UPDATE,
  ],
  availability: [
    PERMISSIONS.AVAILABILITY_CREATE,
    PERMISSIONS.AVAILABILITY_READ,
    PERMISSIONS.AVAILABILITY_UPDATE,
    PERMISSIONS.AVAILABILITY_DELETE,
    PERMISSIONS.AVAILABILITY_MANAGE,
  ],
  bookings: [
    PERMISSIONS.BOOKING_CREATE,
    PERMISSIONS.BOOKING_READ,
    PERMISSIONS.BOOKING_UPDATE,
    PERMISSIONS.BOOKING_DELETE,
    PERMISSIONS.BOOKING_CONFIRM,
    PERMISSIONS.BOOKING_CANCEL,
    PERMISSIONS.BOOKING_COMPLETE,
    PERMISSIONS.BOOKING_ALLVIEW,
  ],
  inventory: [
    PERMISSIONS.INVENTORY_READ,
    PERMISSIONS.INVENTORY_LOG,
    PERMISSIONS.INVENTORY_ADJUST,
  ],
  tenants: [PERMISSIONS.TENANT_MANAGE],
};